/**
 * Get an environment variable, preferring runtime injection via globalThis.__ENV__
 * (written by entrypoint.sh at container startup from Helm extraEnv) over
 * build-time values baked in by Astro (import.meta.env).
 *
 * Usage:
 *   import { getEnv } from '../utils/env'
 *   const apiUrl = getEnv('PUBLIC_API_BASE_URL')
 */
export function getEnv(key: string, fallback = ''): string {
  const runtime = (globalThis as any).__ENV__?.[key]
  if (runtime) return runtime
  return (import.meta.env[key] as string) ?? fallback
}
